import React from 'react'

import useAppStore from '../../../useAppStore';

import './longitude.css';

const Longitude = ({ open, setOpen, title }) => {
    const { isViewOpen, closeView} = useAppStore(); // Access state and actions from the store

  return (
<div>

</div>
  );
}

export default Longitude
